import React from "react";
import "src/styles/pageloader.css";

const FullPageLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-spinner">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default FullPageLoader;